import { getServices } from 'state/actions';
import history from 'lib/history';
import { Notifier } from '@components';
import { http, Logout } from '@services/http';
import i18n from '../../i18n';
import {
  setToken,
  setLocalStorageToken,
  removeLoggedInDetail,
} from '@utils/storage';
import { isNull } from 'lodash';
import CONFIG from '@config';
import { SsoConfiguration } from 'services/http';

export const UPDATE_USER = 'UPDATE_USER';
export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_LOGIN_DETAIL = 'SESSION_LOGIN_DETAIL';
export const SESSIONS_REFETCHED = 'SESSIONS_REFETCHED';

export const authenticate = async (dispatch) => {
  const userResponse = await http.get('/user');
  i18n.changeLanguage(userResponse.data.language.locale);

  dispatch({
    type: SESSION_LOGIN,
    payload: userResponse.data,
  });
  dispatch(getServices());
};

export const loginMicrosoft = (data) => async (dispatch) => {
  console.log(data);
  try {
    setLocalStorageToken(data.data);

    const userResponse = await http.get('/user');

    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch(getServices());
    return Promise.resolve(userResponse.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const loginOpenId = (data) => async (dispatch) => {
  console.log(data);
  try {
    localStorage.setItem('token', JSON.stringify(data.data));

    const userResponse = await http.get('/user');

    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch(getServices());
    return Promise.resolve(userResponse.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const loginIdSign = (credentials) => async (dispatch) => {
  try {
    const loginResponse = await http.post(
      'oauth/user/authenticate',
      credentials,
    );
    setLocalStorageToken(loginResponse.data);

    const userResponse = await http.get('/user');

    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch({
      type: SESSION_LOGIN_DETAIL,
      payload: userResponse.data.login_detail,
    });
    dispatch(getServices());
    return Promise.resolve(userResponse.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const loginSso = (payload) => async (dispatch) => {
  try {
    const loginResponse = await SsoConfiguration.getToken(payload);
    setLocalStorageToken(loginResponse.data);

    const userResponse = await http.get('/user');

    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch({
      type: SESSION_LOGIN_DETAIL,
      payload: userResponse.data.login_detail,
    });
    dispatch(getServices());
    return Promise.resolve(userResponse.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const login = (credentials) => async (dispatch) => {
  try {
    const loginResponse = await http.post('/login', credentials);

    if (loginResponse && loginResponse.data.type === 'mfa') {
      return Promise.resolve(loginResponse.data.type);
    }

    setToken(loginResponse.data);

    const userResponse = await http.get('/user');
    const promise = checkPasswordExpiredFirstLogin(
      userResponse,
      loginResponse.data.token,
    );

    if (!isNull(promise)) return Promise.resolve(promise);
    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch({
      type: SESSION_LOGIN_DETAIL,
      payload: userResponse.data.login_detail,
    });
    dispatch(getServices());

    // Check for saved redirect path
    const redirectPath = sessionStorage.getItem('redirectPath');
    if (redirectPath) {
      sessionStorage.removeItem('redirectPath'); // Clear after use
      history.replace(redirectPath);
    }

    return Promise.resolve(userResponse.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const loginOTP = (data) => async (dispatch) => {
  try {
    const loginResponse = await http.post(`mfa/backoffice/verify`, data);

    setToken(loginResponse.data);

    const userResponse = await http.get('/user');
    const promise = checkPasswordExpiredFirstLogin(
      userResponse,
      loginResponse.data,
    );
    if (!isNull(promise)) return Promise.resolve(promise);

    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch({
      type: SESSION_LOGIN_DETAIL,
      payload: userResponse.data.login_detail,
    });
    dispatch(getServices());
    return Promise.resolve(userResponse.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

const samlLoginToken = (token) => async (dispatch) => {
  try {
    /** SML Login Configuration
     * in this condition we are checking if something wrong to login with token we consider that the token is a SML token
     * First calling saml/authenticate endpoint
     * Then if get token we again call loginToken
     */
    const samlResponse = await http.post('/saml/authenticate ', {
      token,
    });
    dispatch(loginToken({ type: 'Bearer', token: samlResponse.data.token }));
    dispatch(getServices());
  } catch (err) {
    return Promise.reject(err);
  }
};

export const loginToken = (token) => async (dispatch) => {
  try {
    setLocalStorageToken(token);

    const userResponse = await http.get('/user?error=false');
    const promise = checkPasswordExpiredFirstLogin(userResponse, token);
    if (!isNull(promise)) return Promise.resolve(promise);

    i18n.changeLanguage(userResponse.data.language.locale);

    dispatch({
      type: SESSION_LOGIN,
      payload: userResponse.data,
    });
    dispatch({
      type: SESSION_LOGIN_DETAIL,
      payload: userResponse.data.login_detail,
    });
    dispatch(getServices());
    return Promise.resolve(userResponse.data);
  } catch (err) {
    /** Call samlLoginToken if cannot reach to user endpoint
     */
    dispatch(samlLoginToken(token.token));
    return Promise.reject(err);
  }
};

export const logout = () => async (dispatch) => {
  await Logout();
  removeLoggedInDetail();
  dispatch({
    type: SESSION_LOGOUT,
  });
  if (CONFIG.LOGOUT_URL) {
    window.location.replace(CONFIG.LOGOUT_URL);
  } else {
    window.location.reload();
  }
};

export const clearLoginDetail = () => (dispatch) => {
  dispatch({
    type: SESSION_LOGIN_DETAIL,
    payload: {},
  });
};

export const resetPassword = (data, token) => async (dispatch) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await http.patch('/user', data, {
      headers: headers,
    });
    const updatedUser = response.data;
    dispatch({ type: UPDATE_USER, payload: updatedUser });
    Notifier.success('Password updated, login with the new password.');
    return Promise.resolve(updatedUser);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateUser = (data) => async (dispatch) => {
  try {
    const response = await http.patch('/user', data);
    const updatedUser = response.data;
    dispatch({ type: UPDATE_USER, payload: updatedUser });
    Notifier.success('User updated!');
    return Promise.resolve(updatedUser);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const sessionsRefetched = () => (dispatch) => {
  dispatch({
    type: SESSIONS_REFETCHED,
    payload: {},
  });
};

const checkPasswordExpiredFirstLogin = (user, token) => {
  if (user.data.password_expired || user.data.first_login) {
    removeLoggedInDetail();
    const promiseResponse = {
      bearerToUpdatePassword: token,
      user: user.data,
    };
    return promiseResponse;
  }
  return null;
};
